var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"showLabel":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('span',[_vm._v("Label from default slot")])])
}
var staticRenderFns = []

export { render, staticRenderFns }